/**
 * 工程基础配置
 */
import {
  countryMap,
  CountryID,
  CountryCode,
  LanguageId,
  LanguageCode,
  CurrencyCode,
  CurrencyCodeId,
  CountryPhoneCode,
} from "@al/base-lib";
import JsCookie from "js-cookie";

import { COUNTRY_CIRCLE_FLAG, COUNTRY_RECG_FLAG } from "~/common/dict/flag";

export type CountriesInfoItem = {
  countryId?: CountryID;
  countryCode: CountryCode | "PT";
  currencyCode?: CurrencyCode;
  currencyId?: CurrencyCodeId;
  languageCode?: LanguageCode;
  languageId?: LanguageId;
  phoneCode?: CountryPhoneCode | "351";
  timeZone?: number;
  dateFormat?: string;
  circleFlag: string; // 圆形国旗
  recgFlag: string; // 方形国旗
};

// 默认国家配置
export const appCountryConfig = [
  countryMap[CountryCode.DE],
  countryMap[CountryCode.ES],
  countryMap[CountryCode.FR],
  countryMap[CountryCode.IT],
  countryMap[CountryCode.BE],
  countryMap[CountryCode.PL],
];

// 一期支持的国家列表
export const countryList = [CountryID.DE, CountryID.ES, CountryID.FR, CountryID.IT, CountryID.BE, CountryID.PL];

export const countryLanguageMap: Partial<Record<CountryID, LanguageCode>> = {
  [CountryID.DE]: LanguageCode.de,
  [CountryID.ES]: LanguageCode.es,
  [CountryID.FR]: LanguageCode.fr,
  [CountryID.IT]: LanguageCode.it,
  // 比利时也是用的法语
  [CountryID.BE]: LanguageCode.fr,
  [CountryID.PL]: LanguageCode.pl,
};

// 永久 cookie 设置
export const infinityCookieOptions: Omit<JsCookie.CookieAttributes, "expires"> & {
  expires?: Date;
} = { expires: new Date("Fri, 31 Dec 9999 23:59:59") };

export const COUNTRY_OPTIONS: CountriesInfoItem[] = [
  {
    ...countryMap[CountryCode.DE],
    circleFlag: COUNTRY_CIRCLE_FLAG[CountryCode.DE],
    recgFlag: COUNTRY_RECG_FLAG[CountryCode.DE],
  },
  {
    ...countryMap[CountryCode.ES],
    circleFlag: COUNTRY_CIRCLE_FLAG[CountryCode.ES],
    recgFlag: COUNTRY_RECG_FLAG[CountryCode.ES],
  },
  {
    ...countryMap[CountryCode.FR],
    circleFlag: COUNTRY_CIRCLE_FLAG[CountryCode.FR],
    recgFlag: COUNTRY_RECG_FLAG[CountryCode.FR],
  },
  {
    ...countryMap[CountryCode.IT],
    circleFlag: COUNTRY_CIRCLE_FLAG[CountryCode.IT],
    recgFlag: COUNTRY_RECG_FLAG[CountryCode.IT],
  },
  {
    ...countryMap[CountryCode.BE],
    circleFlag: COUNTRY_CIRCLE_FLAG[CountryCode.BE],
    recgFlag: COUNTRY_RECG_FLAG[CountryCode.BE],
  },
  {
    ...countryMap[CountryCode.PL],
    circleFlag: COUNTRY_CIRCLE_FLAG[CountryCode.PL],
    recgFlag: COUNTRY_RECG_FLAG[CountryCode.PL],
  },
  { countryCode: "PT", circleFlag: COUNTRY_CIRCLE_FLAG["PT"], recgFlag: COUNTRY_RECG_FLAG["PT"], phoneCode: "351" }, //葡萄牙
];
